import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { HotsearchList, HotsearchListVariables } from "./types/HotsearchList";

const hotsearchList = gql`
  query HotsearchList(
    # $filter: CollectionFilterInput
    # $sortBy: CollectionSortingInput
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    hotSearch(
      # filter: $filter
      # sortBy:$sortBy
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      totalCount
      edges {
        node {
          id
          hotWord
          description
          sortOrder
        }
      }
    }
  }
`;
export const useHotsearchListQuery = makeQuery<
  HotsearchList,
  HotsearchListVariables
>(hotsearchList);
